import * as React from 'react';
import { Button, SxProps, Theme } from '@mui/material';

interface IconButtonProps {
    icon: React.ReactNode;
    label?: string;
    color?: string;
    onClick?: () => void;
    fontSize?: string;
    sx?: SxProps<Theme>;
}

export const IconButton: React.FC<IconButtonProps> = ({
    label,
    icon,
    onClick,
    fontSize = '16px',
    color = 'var(--color-primary)',
    sx,
}) => {
    return (
        <Button
            startIcon={icon}
            onClick={onClick}
            sx={{
                color: color,
                fontWeight: 700,
                fontSize: fontSize,
                backgroundColor: 'transparent',
                padding: '0',
                minWidth: '30px',
                '& .MuiButton-startIcon': { marginRight: 'var(--space-6)' },
                ...sx,
            }}
        >
            {label}
        </Button>
    );
};
